module.exports = __webpack_public_path__ + "img/special_homeStar.cbaf81ce.png";